import React, { useEffect } from 'react'
import { Skeleton } from 'antd'
import { useDispatch } from 'react-redux'
import {
  // billingActions,
  useBillingSelector,
} from 'store/billingSlice/billingReducer'
import { getBillingTiers } from 'store/billingSlice/billingActions'
import { useAuthSelector } from 'store/authSlice/authReducer'
import { Review, TierSelection } from './components'

const Subscribe = () => {
  const dispatch = useDispatch()
  const { organization } = useAuthSelector()
  const {
    loading: { fetchingTiers },
    tier,
    tiers,
  } = useBillingSelector()

  useEffect(() => {
    dispatch(getBillingTiers(organization?.id))
  }, [dispatch, organization?.id])

  return (
    <Skeleton loading={fetchingTiers} active paragraph={{ rows: 18 }}>
      {tier ? <Review /> : <TierSelection tiers={tiers} />}
    </Skeleton>
  )
}

export { Subscribe }
